import { supabase } from './supabaseClient';

export type AuthSession = Awaited<ReturnType<typeof supabase.auth.getSession>>['data']['session'];

export async function getAuthSession() {
  const { data, error } = await supabase.auth.getSession();
  if (error) throw error;
  return data.session;
}

export function onAuthStateChange(callback: () => void) {
  const { data } = supabase.auth.onAuthStateChange(() => {
    try {
      callback();
    } catch {
      // noop
    }
  });
  return () => {
    try {
      data.subscription.unsubscribe();
    } catch {
      // noop
    }
  };
}

export async function signOutAuth() {
  const { error } = await supabase.auth.signOut();
  if (error) throw error;
}

/**
 * Magic link (OTP) sign-in. Used for staff onboarding and optional passwordless login.
 * UI must not change; callers decide when to use this.
 */
export async function signInWithMagicLink(email: string) {
  const { error } = await supabase.auth.signInWithOtp({
    email,
    options: {
      shouldCreateUser: false,
    },
  });
  if (error) throw error;
}

export async function signInWithPassword(email: string, password: string) {
  const { error } = await supabase.auth.signInWithPassword({ email, password });
  if (error) throw error;
}

export async function signUpWithPassword(email: string, password: string) {
  const { error } = await supabase.auth.signUp({ email, password });
  if (error) throw error;
}

